import { Link } from 'react-router-dom';
import Navbar from '../navigation/Navbar';
import HireTalent from '../app/HireTalent';
import Tips from '../JobHome/Tips';
import Blogs from '../app/Blogs';
import Categories from '../app/Categories';
import Footer from '../../components/app/Footer';
import JobDesc from '../DailyJobs/JobDesc';
import { Typography } from '@mui/material';
import toList from '../utils/ComponentUtil';
import TalentsAPI from '../Apis/TalentsAPI';
import PostProjectTemplate from './PostProjectTemplate';
import { useEffect, useState } from 'react';


function PostProjectPage() {
    const [project, setProject] = useState();
    const [projects, setProjects] = useState();

    useEffect(() => {
        if(project) {
            let t = TalentsAPI.getTalentsByType(project);
            setProjects(t);
        }
    }, [project])

    const breadcrumbs = [toList([{ to: "/", child: "Home" }], Link), <Typography className="job-page-name">Post Your Project</Typography>]

    return (
        <>
        <Navbar selected='Find Talents'/>
        <JobDesc talents={projects} talentsTitle={project + ' Projects'} breadcrumbs={breadcrumbs} startPosting={false} render={() => {
            return <PostProjectTemplate setter={setProject}/>
        }}></JobDesc>
        <HireTalent/>
        <Tips/>
        <Blogs></Blogs>
        <Categories></Categories>
        <Footer></Footer>
        </>
    );
}

export default PostProjectPage;